import { Permission } from "../interface/types";

export const admin_permissions: Permission[] = [
  "CAN_VIEW_TRANSACTIONS",
  "CAN_VIEW_USERS",
  "CAN_VIEW_CUSTOMERS",
  "CAN_INVITE_USERS",
  "CAN_VIEW_SETTLEMENTS",
  "CAN_PROCESS_SETTLEMENT",
  "CAN_UPDATE_SETTLEMENT_ACCOUNT",
  "CAN_ADD_ROLE",
  "CAN_UPDATE_ROLE",
  "CAN_ASSIGN_ROLE",
];
export const formatPermission = (permission: string) => {
  // Remove the CAN_ prefix and replace underscores with spaces
  const formatted = permission.replace("CAN_", "").replace(/_/g, " ");
  return formatted
    .split(" ")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
};

export const payments_status = ["CREATED", "SUCCESSFUL", "FAILED"];

export const settlement_status = [
  "PAID",
  "UNPAID",
  "FAILED",
  "UNKNOWN",
  "ACTIVE",
  "COMPLETED",
];

export const formatDateTime = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

// Format currency
export const formatCurrency = (amount: number, currency: string) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
  }).format(amount);
};

// Helper function to format permission labels for display
export function formatPermissionLabel(permission: string): string {
  return permission
    .replace(/_/g, " ")
    .split(" ")
    .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
    .join(" ");
}

export const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, "0")}:${secs
    .toString()
    .padStart(2, "0")}`;
};
